<template>
    <div class="kgk-upload-image">
        <!--<ul>
            <li v-for="(file, index) in files" :key="index">{{file.name}} - Error: {{file.error}}, Success: {{file.success}}</li>
        </ul>
        <file-upload
                ref="upload"
                v-model="files"
                :multiple="false"
                :size="1024 * 1024 * 5"
                extensions="png,jpg,jpeg"
                accept="image/png,image/jpeg"
                :post-action="getUploadUrl()"
                @input-filter="inputFilter"
                @input-file="inputFile"
                :headers="customHeaders">
            {{ buttonText }}
        </file-upload>
        <button v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" type="button">Start upload</button>
        <button v-show="$refs.upload && $refs.upload.active" @click.prevent="$refs.upload.active = false" type="button">Stop upload</button>-->

        <div style="display:none;">
            <input v-if="uploadReady" type="file" id="files" ref="files" @change.prevent="handleFilesChanged" />
        </div>
        <button type="button" @click.prevent="$refs.files.click()">
            <i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
            <i v-else-if="buttonIcon" :class="buttonIcon + ' fa-fw'"></i>
            <span class="button-text">{{ buttonText }}</span>
        </button>
    </div>
</template>

<script>
    import upload from '../../api/upload';

    export default {
        name: 'ImageUpload',
        components: {

        },
        props: {
            type: {
                type: String,
                required: true
            },
            buttonText: {
                type: String,
                required: true
            },
            buttonIcon: String,
            /*insideModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
            runIdentifier: {
                type: String,
                required: false
            },*/
        },
        data() {
            return {
                loading: false,
                //files: [],
                uploadReady: true,
            }
        },
        computed: {
            /*customHeaders() {
                return {
                    'Authorization': 'Bearer ' + this.$global.session.token
                };
            }*/
        },
        methods: {
            /*getUploadUrl() {
                if( typeof window.kgkRoutes.uploads[this.type] === 'undefined' ) {
                    console.error(`no api route for upload type ${this.type} found`);
                }
                return window.kgkRoutes.uploads[this.type];
            },*/

            clearFileInput() {
                this.uploadReady = false;
                this.$nextTick(() => this.uploadReady = true);
            },

            handleFilesChanged() {
                if( this.loading ) {
                    return;
                }

                if( this.$refs.files.files.length < 1 ) {
                    return;
                }

                console.log(this.$refs.files.files);

                const file = this.$refs.files.files[0];

                if( !this.checkFile(file) ) {
                    return;
                }

                const formData = new FormData();

                formData.append('file', file);

                this.loading = true;

                upload[this.type](
                    this,
                    formData,
                    data => {
                        this.$notify({
                            type: 'success',
                            title: 'Dateiupload',
                            text: 'Die Datei wurde erfolgreich hochgeladen.'
                        });

                        //console.log(data);
                        this.$emit('uploaded', data.url, data.fileExtension);
                    },
                    e => {
                        console.error('upload error', e);

                        if( typeof e.response.data.message !== 'undefined' ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        this.clearFileInput();
                    }
                );
            },

            checkFile(file) {
                if( file.size && file.size >= 1024 * 1024 * 5 ) {
                    this.$notify({
                        type: 'error',
                        title: 'Datei ist zu groß',
                        text: 'Die Datei darf nicht größer als 5 MB sein.'
                    });

                    return false;
                }

                if( file.type && ['image/jpg', 'image/jpeg', 'image/png'].indexOf(file.type) === -1 ) {
                    this.$notify({
                        type: 'error',
                        title: 'Unerlaubter Dateityp',
                        text: 'Es können nur .jpg oder .png Bilder hochgeladen werden.'
                    });

                    return false;
                }

                return true;
            },

            /*inputFilter(newFile, oldFile, prevent) {
                if( newFile && !oldFile ) {
                    // Filter non-image file
                    if( !/\.(jpeg|jpg|png)$/i.test(newFile.name)) {
                        return prevent();
                    }
                }

                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
            },

            inputFile(newFile, oldFile) {
                if( newFile && oldFile && !newFile.active && oldFile.active ) {
                    // Get response data
                    console.log('response', newFile.response)

                    if( newFile.xhr ) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status)
                    }
                }
            },*/
        },
        watch: {

        },
        mounted() {

        }
    }

    // extensions="gif,jpg,jpeg,png,webp"
    // accept="image/png,image/gif,image/jpeg,image/webp"
</script>
